export default "__VITE_ASSET__DUxpqdRj__"